import React, { useEffect } from 'react';
import './snackbar.css';

interface SnackbarProps {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  onClose?: () => void;
  durationMs?: number;
}

const Snackbar: React.FC<SnackbarProps> = ({ message, actionLabel, onAction, onClose, durationMs = 6000 }) => {
  useEffect(() => {
    const t = setTimeout(() => onClose && onClose(), durationMs);
    return () => clearTimeout(t);
  }, [onClose, durationMs]);

  return (
    <div className="snackbar" role="status" aria-live="polite">
      <div className="snackbar-message">{message}</div>
      {actionLabel && <button className="snackbar-action" onClick={() => { onAction && onAction(); onClose && onClose(); }}>{actionLabel}</button>}
      <button className="snackbar-close" aria-label="close" onClick={onClose}>×</button>
    </div>
  );
};

export default Snackbar;
